import { render, staticRenderFns } from "./ServiceActionsList.vue?vue&type=template&id=27305fba&scoped=true"
import script from "./ServiceActionsList.vue?vue&type=script&lang=js"
export * from "./ServiceActionsList.vue?vue&type=script&lang=js"
import style0 from "./ServiceActionsList.vue?vue&type=style&index=0&id=27305fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27305fba",
  null
  
)

export default component.exports